module.exports = __webpack_public_path__ + "static/media/PERSONALIZE_IMG.b5de5636.webp";